__turbopack_context__.v({
  "actions": "MessageSequence-module__xlBZoG__actions",
  "addBtn": "MessageSequence-module__xlBZoG__addBtn",
  "addRow": "MessageSequence-module__xlBZoG__addRow",
  "bar": "MessageSequence-module__xlBZoG__bar",
  "card": "MessageSequence-module__xlBZoG__card",
  "cardTop": "MessageSequence-module__xlBZoG__cardTop",
  "channel": "MessageSequence-module__xlBZoG__channel",
  "channelOption": "MessageSequence-module__xlBZoG__channelOption",
  "copyBtn": "MessageSequence-module__xlBZoG__copyBtn",
  "copySlot": "MessageSequence-module__xlBZoG__copySlot",
  "emptyText": "MessageSequence-module__xlBZoG__emptyText",
  "loading": "MessageSequence-module__xlBZoG__loading",
  "loadingText": "MessageSequence-module__xlBZoG__loadingText",
  "popoverAddBtn": "MessageSequence-module__xlBZoG__popoverAddBtn",
  "popoverContent": "MessageSequence-module__xlBZoG__popoverContent",
  "popoverFooter": "MessageSequence-module__xlBZoG__popoverFooter",
  "popoverInput": "MessageSequence-module__xlBZoG__popoverInput",
  "popoverItem": "MessageSequence-module__xlBZoG__popoverItem",
  "popoverList": "MessageSequence-module__xlBZoG__popoverList",
  "step": "MessageSequence-module__xlBZoG__step",
  "stepActions": "MessageSequence-module__xlBZoG__stepActions",
  "stepBody": "MessageSequence-module__xlBZoG__stepBody",
  "stepDay": "MessageSequence-module__xlBZoG__stepDay",
  "stepIcon": "MessageSequence-module__xlBZoG__stepIcon",
  "stepLine": "MessageSequence-module__xlBZoG__stepLine",
  "stepName": "MessageSequence-module__xlBZoG__stepName",
  "stepTemplate": "MessageSequence-module__xlBZoG__stepTemplate",
  "stepTimeline": "MessageSequence-module__xlBZoG__stepTimeline",
  "stepTitle": "MessageSequence-module__xlBZoG__stepTitle",
  "steps": "MessageSequence-module__xlBZoG__steps",
  "templateLoading": "MessageSequence-module__xlBZoG__templateLoading",
  "templateSkeleton": "MessageSequence-module__xlBZoG__templateSkeleton",
  "templateWrap": "MessageSequence-module__xlBZoG__templateWrap",
  "updateAgo": "MessageSequence-module__xlBZoG__updateAgo",
  "updateBanner": "MessageSequence-module__xlBZoG__updateBanner",
  "updateText": "MessageSequence-module__xlBZoG__updateText",
  "variantTab": "MessageSequence-module__xlBZoG__variantTab",
  "variantTabActive": "MessageSequence-module__xlBZoG__variantTabActive",
  "variantTabAdd": "MessageSequence-module__xlBZoG__variantTabAdd",
  "variantTabFull": "MessageSequence-module__xlBZoG__variantTabFull",
  "variantTabShort": "MessageSequence-module__xlBZoG__variantTabShort",
  "variantTabs": "MessageSequence-module__xlBZoG__variantTabs",
});
